import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { JobOrderBoardInterface } from '../interfaces/job-order-board.interface';
import { BuilderDto } from '../../builder/dto/builder.dto';
import { SpOrderDto } from '../../sp/order/dtos/sp-order.dto';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { JobDto } from '../../job/dto/job.dto';

@Exclude()
export class JobOrderBoardDto
  extends CommonEntityDto
  implements JobOrderBoardInterface
{
  @ApiProperty({
    title: 'SP Order ID',
    type: 'uuid',
  })
  @IsUUID()
  @Expose()
  spOrderId!: string;

  @ApiProperty({
    title: 'Job ID',
    type: 'uuid',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'Item description ID',
    type: 'uuid',
  })
  @IsUUID()
  @Expose()
  itemDescriptionId!: string;

  @ApiProperty({ title: 'Order Item Description', type: 'string' })
  @Expose()
  itemDescription!: string;

  @ApiProperty({ title: 'Board type name', type: 'string' })
  @Expose()
  boardTypeName!: string;

  @ApiProperty({ title: 'Board type short name', type: 'string' })
  @Expose()
  boardTypeShortname!: string;

  @ApiProperty({
    type: 'boolean',
    title: 'Sp builder board type is active?',
    nullable: true,
  })
  @Expose()
  active!: boolean | null;

  @ApiProperty({
    type: 'number',
    title: 'Total of quantity ordered by board',
  })
  @Expose()
  totalQuantityOrdered!: number;

  @ApiProperty({
    title: 'Builder Id',
    nullable: true,
  })
  @Expose()
  builderId!: string;

  @ApiPropertyOptional({
    type: () => [BuilderDto],
    title: 'Builder',
    description: 'The builder associated with this job order item',
  })
  @Expose()
  builder!: BuilderDto;

  @ApiPropertyOptional({
    type: () => [SpOrderDto],
    title: 'Builder',
    description: 'The sp order associated with this job order item',
  })
  @Expose()
  spOrder!: SpOrderDto;

  @ApiPropertyOptional({
    type: () => [JobDto],
    title: 'Builder',
    description: 'The job associated with this job order board',
  })
  @Expose()
  job!: JobDto;
}
